import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { cn } from '../../lib/utils';

export const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(() => typeof navigator !== 'undefined' && !navigator.onLine);
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setJustReconnected(false);
    };

    const handleOnline = () => {
      setIsOffline(false);
      setJustReconnected(true);
      const timer = setTimeout(() => {
        setJustReconnected(false);
      }, 3500);
      return () => clearTimeout(timer);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline && !justReconnected) return null;

  if (justReconnected) {
    return (
      <div className="bg-emerald-500 text-white border-b-4 border-black dark:border-white px-4 py-2 flex items-center justify-center gap-3 text-xs font-mono font-black uppercase tracking-widest z-[65] relative animate-in fade-in slide-in-from-top duration-300">
        <Wifi size={16} className="shrink-0" />
        <span>Connection Restored. Synchronizing with cloud.</span>
      </div>
    );
  }

  return (
    <div className="bg-[#FFD600] text-black border-b-4 border-black dark:border-white px-4 py-2.5 flex items-center justify-center gap-3 text-xs font-mono font-black uppercase tracking-widest z-[65] relative animate-in fade-in slide-in-from-top duration-300 shadow-[0_4px_0_#000000]">
      <WifiOff size={16} className="text-black shrink-0 animate-pulse" />
      <span>You are currently offline. Changes will not sync until connection returns.</span>
    </div>
  );
};
